(() => {
  if (customElements.get('sdc-gift-catalog')) return;
  customElements.define('sdc-gift-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.ready || this.dataset.curated !== 'true') return;
      this.ready = true; this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.links = [...this.querySelectorAll('[data-category]')];
      this.groups = [...this.querySelectorAll('[data-gift-group]')];
      this.budgets = [...this.querySelectorAll('[data-budget]')];
      const money = new Intl.NumberFormat(this.dataset.locale, { style:'currency', currency:this.dataset.currency });
      const entries = new Map([...this.querySelectorAll('[data-gift-entry]')].map(entry => [entry, {
        variants: JSON.parse(entry.querySelector('[data-entry-variants]').textContent),
        price: entry.querySelector('.sdc-gift-price').textContent,
        href: entry.querySelector('.sdc-gift-card a').getAttribute('href')
      }]));
      const words = JSON.parse(this.querySelector('[data-gift-words]').textContent);
      this.render = () => {
        const params = new URL(location.href).searchParams;
        const rawCategory = params.get('gift_category'), rawBudget = params.get('gift_budget');
        const category = ['bubu','mugs','custom'].includes(rawCategory) ? rawCategory : 'all';
        const budget = ['10-25','25-50','50-up'].includes(rawBudget) ? rawBudget : 'all';
        const ranges = {'all':[0,Infinity],'10-25':[1000,2500],'25-50':[2500,5000],'50-up':[5000,Infinity]};
        let total = 0;
        this.groups.forEach(group => {
          let count = 0;
          group.querySelectorAll('[data-gift-entry]').forEach(entry => {
            const data = entries.get(entry);
            const match = data.variants.filter(variant => variant.available && Number(variant.price) >= ranges[budget][0] && Number(variant.price) < ranges[budget][1]).sort((a,b) => Number(a.price)-Number(b.price))[0];
            const matches = budget === 'all' || Boolean(match);
            entry.hidden = !matches;
            const label = entry.querySelector('[data-matched-variant]');
            if (label) { label.hidden = budget === 'all' || !match || match.title === 'Default Title'; label.textContent = match?.title || ''; }
            const price = entry.querySelector('.sdc-gift-price'), link = entry.querySelector('.sdc-gift-card a');
            price.textContent = budget === 'all' || !match ? data.price : money.format(Number(match.price)/100);
            if (budget === 'all' || !match) link.setAttribute('href',data.href);
            else { const url = new URL(data.href,location.origin); url.searchParams.set('variant',match.id); link.setAttribute('href',url.pathname+url.search); }
            if (matches) count++;
          });
          const active = category === 'all' || group.dataset.giftGroup === category;
          group.hidden = !active || count === 0;
          if (active) total += count;
        });
        this.querySelector('[data-category-intro]').hidden = category !== 'all' || budget !== 'all';
        this.querySelector('[data-gift-count]').textContent = words.results.replace('__COUNT__',String(total));
        this.querySelector('[data-gift-empty]').hidden = total !== 0;
        this.budgets.forEach(input => { input.checked = input.value === budget; });
        this.links.forEach(link => {
          if (link.dataset.category === category) link.setAttribute('aria-current','page');
          else link.removeAttribute('aria-current');
        });
      };
      this.links.forEach(link => link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        const url = new URL(location.href);
        if (link.dataset.category === 'all') url.searchParams.delete('gift_category');
        else url.searchParams.set('gift_category',link.dataset.category);
        history.pushState({},'',url); this.render();
        const group = this.querySelector('[data-gift-group]:not([hidden])');
        if (link.closest('[data-category-intro]') && group) group.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }, options));
      this.budgets.forEach(input => input.addEventListener('change', () => {
        const url = new URL(location.href);
        if (input.value === 'all') url.searchParams.delete('gift_budget');
        else url.searchParams.set('gift_budget',input.value);
        history.pushState({},'',url); this.render();
        this.querySelector('.sdc-gift-budget').open = false;
      }, options));
      window.addEventListener('popstate', this.render, options); this.render();
    }
    disconnectedCallback(){ this.abort?.abort(); }
  });
})();
